import ScheduledLessonPlanItem from '@/models/ScheduledLessonPlanItem';
import { Table } from '@/components/ui/daisy';
import { useTranslation } from 'react-i18next';
import useScheduledLessonPlanItemsHandler from '@/data/hook/scheduled-lesson-plan-items/useScheduledLessonPlanItemsHandler';
import ScheduledLessonPlanItemCheckbox from './ScheduledLessonPlanItemCheckbox';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

export type scheduledLessonPlanItemsProps = {
  scheduledLessonId: number;
  scheduledLessonPlanItems: ScheduledLessonPlanItem[];
};

export default function ScheduledLessonPlanItems({
  scheduledLessonId,
  scheduledLessonPlanItems,
}: scheduledLessonPlanItemsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'scheduledLessonReportModal',
  });

  const { toggleHasDone, isLoading } = useScheduledLessonPlanItemsHandler({
    scheduledLessonId,
    scheduledLessonPlanItems,
  });

  return (
    <div className="flex flex-col gap-4">
      <h2 className="font-semibold leading-7 text-base">{t('classItems')}</h2>
      <Table.Container className="w-full rounded-2xl">
        <Table pinRows className="bg-base-200">
          <Table.Head>
            <Table.Row className="bg-transparent text-xs">
              <Table.HeaderCell className="w-[90%] text-start">
                {t('columns.description')}
              </Table.HeaderCell>
              <Table.HeaderCell className="w-[10%] text-center">
                {t('columns.concluded')}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            <ConditionalRenderer
              condition={scheduledLessonPlanItems.length}
              fallback={
                <Table.Row>
                  <Table.Cell colSpan={2} className="text-center">
                    {t('noItems')}
                  </Table.Cell>
                </Table.Row>
              }
            >
              {scheduledLessonPlanItems.map(item => (
                <Table.Row key={item.id} className="text-sm">
                  <Table.Cell className="w-[90%] text-start">
                    {item.lessonPlanItem.name}
                  </Table.Cell>
                  <Table.Cell className="flex justify-center">
                    <ScheduledLessonPlanItemCheckbox
                      hasDone={item.hasDone}
                      disabled={isLoading}
                      onChange={() => toggleHasDone(item.id)}
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </ConditionalRenderer>
          </Table.Body>
        </Table>
      </Table.Container>
    </div>
  );
}
